import { GetPurchaseOrdersResponse } from '@freighthub/freighthub-purchase-order-management-client'
import { useApi } from 'service/useApi'

import { IPagination } from '../domain/IPagination'

export function usePurchaseOrderApi() {
  const api = useApi()

  const purchaseOrderEndpoints = {
    getPurchaseOrdersByIds: (ids: string[], params: IPagination = {}) => {
      const idQueryParams = new URLSearchParams()
      ids.forEach((id) => {
        idQueryParams.append('id', id)
      })
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- TODO: Fix template expression
      return api.http.get<GetPurchaseOrdersResponse>(`/pom/v2/purchase-orders?${idQueryParams}`, { params })
    },
    getPurchaseOrdersByShipmentId: (shipmentId: string, params: IPagination = {}) => {
      return api.http.get<GetPurchaseOrdersResponse>(`/pom/v2/purchase-orders?shipmentID=${shipmentId}`, { params })
    },
  }
  return {
    ...purchaseOrderEndpoints,
  }
}
export type PurchaseOrderApi = ReturnType<typeof usePurchaseOrderApi>
